import { verifyProfileService } from '@http/profileService'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import { call, takeEvery, put, select } from 'redux-saga/effects'
import { verify, verifyFailed, verifySuccess } from './homeSlice'

export function* verifyHttp() {
  const { cocap, userId } = yield select(selectCredentials)
  try {
    const tree = yield call(verifyProfileService, userId, cocap)
    yield put(verifySuccess(tree))
  } catch (e) {
    yield put(verifyFailed(e.message))
  }
}

export default function* verifySaga() {
  yield takeEvery(verify.type, verifyHttp)
}
